import { observer } from 'mobx-react';

import { useClientSettingStore, useStore } from '@assets/model/Store';
import { Button } from 'react-bootstrap';
import * as style from './ExportVarsOutput.module.less';
import { get, getDatabase, onValue, ref } from 'firebase/database';
import { generateVariablesOutputDownload } from '@assets/utils/Utils';

function downloadStringAsFile(text, fileName, mimeType = 'text/plain') {
    const blob = new Blob([text], { type: mimeType });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export const ExportVarsOutput = observer(() => {
    const store = useStore();
    const clientStore = useClientSettingStore();

    const create_output_vars_file = async () => {
        const companyId = store.selectedReportId;
        await generateVariablesOutputDownload(companyId, null);
    };

    return (
        <Button
            variant="light"
            className={style.exportButton}
            onClick={create_output_vars_file}
        >
            <i className="bi bi-download"></i>
            Export Outputs
        </Button>
    );
});
